import {getEnv} from '../../common/env/env';
import {AssetPropertyDto} from '../../common/shared/api/nicolas/vo/AssetPropertyDto.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {AssetProperty} from '../generated/types';

export function createAssetProperty({
  banner_img,
  card_img,
  card_text_img,
  clean_img,
  ipx_video,
  banner_set,
}: AssetPropertyDto): AssetProperty {
  return {
    bannerImage: banner_img
      ? banner_img.startsWith('http')
        ? banner_img
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: banner_img,
            resolution: 'th3',
          })
      : undefined,
    cardImage: card_img
      ? card_img.startsWith('http')
        ? card_img
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: card_img,
            resolution: 'th3',
          })
      : undefined,
    cardTextImage: card_text_img
      ? card_text_img.startsWith('http')
        ? card_img
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: card_text_img,
            resolution: 'th3',
          })
      : undefined,
    cleanImage: clean_img
      ? clean_img.startsWith('http')
        ? clean_img
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: clean_img,
            resolution: 'th3',
          })
      : undefined,
    ipxVideo: ipx_video,
    bannerSet: banner_set
      ? {
          backgroundImage: banner_set.background_img,
          backgroundColor: banner_set.background_color,
          mainImage: banner_set.main_img,
          titleImage: banner_set.text_img,
        }
      : undefined,
  };
}
